var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "a",
      {
        staticClass: "text-muted ms-auto d-lg-none",
        attrs: {
          href: "#offcanvasResponsive",
          role: "button",
          "data-bs-toggle": "offcanvas",
          "data-bs-target": "#offcanvasResponsive",
          "aria-controls": "offcanvasResponsive",
        },
      },
      [_c("i", { staticClass: "fas fa-list" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }